import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getSyncErrors(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('admin-report/contract-not-synchronized', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deletePaymentRemittanceItem(ctx, data) {
      return new Promise((resolve, reject) => {
        axios
          .delete('/payment-remittance/delete-item', { data })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    omieReSync(ctx, { contractId }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`contract/omie-re-sync/${contractId}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    contractHistory(ctx, { contractId }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`contract/last-api-record/${contractId}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
